import InsightsIcon from '@mui/icons-material/Insights';
import IconButton from '@mui/material/IconButton';
import { useSearchParams } from 'hooks/useSearchParams';

export const INSIGHTS_DOC_ID_KEY = 'insightsDocId';

export function InsightsButton({ documentId }: { documentId: string | undefined }) {
  const [, setSearchParams] = useSearchParams();

  if (!documentId) {
    return null;
  }

  const openInsights = () => {
    setSearchParams(
      (prev) => {
        prev.set(INSIGHTS_DOC_ID_KEY, documentId);
        return prev;
      },
      { replace: true }
    );

    window.dispatchEvent(new CustomEvent('urlParamChanged', { detail: { key: INSIGHTS_DOC_ID_KEY } }));
  };

  return (
    <IconButton aria-label="Insights" onClick={openInsights}>
      <InsightsIcon color="primary" />
    </IconButton>
  );
}
